import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import Slider from '../../components/Slider';

import styles from './styles';

class B7Slider extends React.Component {
  renderBackground() {
    const { classes } = this.props;
    return (
      <div className={classes.background}>
        <div className={classes.blueCircle}></div>
      </div>
    );
  }

  renderContent() {
    const { classes, data } = this.props;
    return (
      <div className={classes.content}>
        {/* <Slider sliderData={data.blocks.b7slider} imgPath="blocks"></Slider> */}
        <Slider sliderData={data.blocks.b7slider} imgPath="blocks" imgFormat="imgContain"></Slider>
      </div>
    );
  }

  render() {
    const { classes } = this.props;
    return (
      <div className={classes.blockContainer}>
        {this.renderBackground()}
        {this.renderContent()}
      </div>
    );
  }
}

B7Slider.propTypes = {
  classes: PropTypes.object.isRequired,
  data: PropTypes.object,
};

export default withStyles(styles)(B7Slider);
